import { EmboBusiness } from '@/infrastructure';
import { Organisation } from '@/models/organisation';
import { IOrganisation } from '@studyportals/sp-millennium-falcon';

import { OrganisationNotFoundResult } from './organisation-not-found-result';
import { OrganisationSearchResult } from './organisation-search-result';
import { AbstractAndReportExceptionAsync } from '@studyportals/mb-platform-exceptions-aop';

class OrganisationPresenter {
	@AbstractAndReportExceptionAsync()
	public async searchForIdentity(identity: string): Promise<OrganisationSearchResult> {
		try {
			const organisations = await EmboBusiness.getOrganisations([identity]);

			if (0 === organisations.length) {
				return new OrganisationNotFoundResult();
			}

			const firstOrganisation = this.reconstituteOrganisation(organisations[0]);

			return new OrganisationSearchResult(firstOrganisation);
		} catch (e) {
			return new OrganisationNotFoundResult();
		}
	}

	private reconstituteOrganisation(input: IOrganisation): Organisation {
		return new Organisation(input.id, input.title);
	}
}

export default new OrganisationPresenter();
